import { TableOperationHeader } from '@getsynapse/design-system';
import MoreActionsPopup, {
  OptionProps,
} from 'Organisms/TableHeaderActionButtons/MoreActionsPopup';
import React from 'react';
import intl from 'react-intl-universal';

import exportIcon from 'assets/icons/export.svg';
import AppliedFiltersTags from 'Organisms/AppliedFiltersTags/AppliedFiltersTags';
import useBudgetFilters from 'Pages/BudgetsPage/hooks/useBudgetFilters';
import { useDispatch } from 'react-redux';
import { setBudgetReportFilters } from 'state/BudgetList/budgetListSlice';
import { BudgetFilters } from 'utils/constants/budget';
const BudgetReportTableHeader: React.FC<{
  appliedFilters: BudgetFilters;
  saveFilters: (updatedFilters: BudgetFilters) => void;
  toggleFilterComponent: () => void;
  exportCsvData: () => void;
}> = ({
  appliedFilters,
  saveFilters,
  toggleFilterComponent,
  exportCsvData,
}) => {
  const { getOptionsByKey } = useBudgetFilters();
  const dispatch = useDispatch();

  const handleUpdateFilters = (updatedFilters: BudgetFilters) => {
    dispatch(setBudgetReportFilters(updatedFilters));
    saveFilters(updatedFilters);
  };
  const tableActionsList: Partial<OptionProps>[] = [
    {
      label: intl.get('EXPORT'),
      selectOption: () => {
        exportCsvData();
      },
      iconSrc: exportIcon,
    },
  ];

  return (
    <div className='px-px'>
      <TableOperationHeader
        className='border-b-0'
        searchInputContainerClassName='z-5'
        hideSearch={true}
        actionButtons={
          <>
            <MoreActionsPopup options={tableActionsList} />
          </>
        }
      />
      <AppliedFiltersTags<BudgetFilters>
        savedFilters={appliedFilters}
        onUpdateFilters={handleUpdateFilters}
        onDisplayAllFilters={toggleFilterComponent}
        getOptionsbyKey={getOptionsByKey}
        dataTestid='applied-budget-filters-tags'
      />
    </div>
  );
};

export default BudgetReportTableHeader;
